import SimpleKeyboard from "./components/Keyboard";
export default SimpleKeyboard;
